export const HOST = [
    'https://test-oauth.ihuhoo.com/user',
    'https://oauth.tradeup.com/user',
    'https://test-oauth.ihuhoo.com/user'
];

export const API = {
    // 针对个人中心提供的专门接口: https://tigertech.feishu.cn/wiki/wikcnVaEGJoXs5JxX6hKKaihN8L#
    webUserStatus: '/api/v2/web/user/status',

    // https://apidocs.tigerfintech.com/repository/83/api/master/APIs/profile.json#/operations/post-api-v1-user-cancellation-apply
    // @huangcong
    closeAccount: '/api/v1/user/cancellation', // 是否已经提交注销请求了
    closeAccountApply: '/api/v1/user/cancellation/apply' // 提交注销账号申请
};
